interface IconProps {
  variant?: 'party' | 'link'
}

export const BeamIcon = ({ variant = 'party' }: IconProps) => {
  let variantIcon // needs to be the Unicode not HTML
  switch (variant) {
    case 'party':
      variantIcon = '🎉'
      break
    case 'link':
      variantIcon = '🔗'
      break
  }
  return <span data-testid={`${variant}-icon`}>{variantIcon}</span>
}
